import { App } from 'antd';

export default function useNotify() {
  const { notification } = App.useApp();

  return {
    success: (config) =>
      notification.success({
        placement: 'bottomRight',
        ...config,
      }),
    error: (config) =>
      notification.error({
        placement: 'bottomRight',
        ...config,
      }),
    info: (config) =>
      notification.info({
        placement: 'bottomRight',
        ...config,
      }),
    warning: (config) =>
      notification.warning({
        placement: 'bottomRight',
        ...config,
      }),
  };
}
